import { render } from "./FoodForm.vue?vue&type=template&id=5d4c377f"
import script from "./FoodForm.vue?vue&type=script&lang=js"
export * from "./FoodForm.vue?vue&type=script&lang=js"

import "./FoodForm.vue?vue&type=style&index=0&id=5d4c377f&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__